import '.fm{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fn{padding-left:1.5rem;}.ssr-plugin'
import '.fo{margin:1rem 0;}.ssr-plugin'
import '.fp{color:var(--gray-700);}.ssr-plugin'
import '.fq{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fm fn fo fp fq"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
